<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<div class="main" data-request="1995">
  <div class="wrap">
    <div class="sub-request elem" style="display: block;">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <h2 style="text-align: center">اطلاعات درخواست بیمه
            </h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12"
             *ngFor="let request of requestInfo; let last = last">
          <app-details-div
            [rawCount]="3"
            [icon]="icon"
            [array]="request.getViewArray()"
            [header]="request.getRequestID() + ''"
            [id]="request.getRequestID()"
            (takeAction)="takeAction()"
            [mainLabel]="buttonLabel"
            [backLabel]="'بیمه های من'"
            [backUrl]="'/MOBILE/requests'"
          ></app-details-div>
        </div>
      </div>
      <!--      <app-custom-button-->
      <!--        [Show]="true"-->
      <!--        [LabelText]="buttonLabel"-->
      <!--        [BackButton]="true"-->
      <!--        [backUrl]="'/mobile/my-requests'"-->
      <!--        (OnClick)="takeAction()"-->
      <!--        [HideMainButton]="buttonLabel  === ''"-->
      <!--        [backButtonLabel]="'بیمه های من'"-->
      <!--      ></app-custom-button>-->
    </div>
  </div>
</div>
<div *ngIf="paymentMode">
  <app-finance-invoice-div
    (OnClickOutSide)="hideFinance()"
    [show]="paymentMode"
    [productName]="'MOBILE'"
    [RequestID]="requestID"
  ></app-finance-invoice-div>
</div>

<app-file-upload-div
  [fileInfo]="fileInfo"
  [productName]="'MOBILE'"
  (ClickOutSide)="hideUpload()">
</app-file-upload-div>
